import {IBanner} from '../interface/IBanner';

export class Banner implements IBanner {

  id?: number;
  titulo?: string;
  descripcion?: string;
  imagen?: string;
  nuevaImagen?: any;
  url?: string;
  tipo?: string;
  esPublicado?: boolean;
  orden?: number;
  fecInicio?: Date;
  fecFin?: Date;
  fecCreacion?: Date;
  fecModificacion?: Date;
  modificado?: boolean;
  esNuevo?: boolean;

  constructor(banner: IBanner) {
    this.id = banner.id;
    this.titulo = banner.titulo;
    this.descripcion = banner.descripcion;
    this.imagen = banner.imagen;
    this.nuevaImagen = banner.nuevaImagen;
    this.url = banner.url;
    this.tipo = banner.tipo;
    this.esPublicado = banner.esPublicado;
    this.orden = banner.orden;
    this.fecInicio = banner.fecInicio;
    this.fecFin = banner.fecFin;
    this.fecCreacion = banner.fecCreacion;
    this.fecModificacion = banner.fecModificacion;
    this.fecModificacion = banner.fecModificacion;
    this.modificado = banner.modificado;
    this.esNuevo = banner.esNuevo;
  }


  getFormData(): FormData {
    const formData = new FormData();
    if (typeof this.titulo !== 'undefined') {
      formData.append('titulo', this.titulo);
    }
    if (typeof this.descripcion !== 'undefined') {
      formData.append('descripcion', this.descripcion);
    }
    if (typeof this.url !== 'undefined') {
      formData.append('url', this.url);
    }
    if (typeof this.tipo !== 'undefined') {
      formData.append('tipo', this.tipo);
    }
    if (this.esPublicado) {
      formData.append('esPublicado', 'PUBLICADO');
    } else {
      formData.append('esPublicado','NO_PUBLICADO');
    }
    if (typeof this.orden !== 'undefined') {
      formData.append('orden', String(this.orden));
    }
    if (typeof this.nuevaImagen !== 'undefined') {
      formData.append('file_upload', this.nuevaImagen, this.nuevaImagen.name);
    }

    return formData;
  }

  getFormDataOrden(): FormData {
    const formData = new FormData();
    if (typeof this.orden !== 'undefined') {
      formData.append('orden', String(this.orden));
    } else {
      formData.append('orden', '0');
    }

    if (this.esPublicado) {
      formData.append('esPublicado', 'PUBLICADO');
    } else {
      formData.append('esPublicado', 'NO_PUBLICADO');
    }
    return formData;
  }

}



// WEBPACK FOOTER //
// /app/src/model/class/Banner.ts